import { AppBar, Button, Grid2, IconButton, Typography } from '@mui/material';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';

interface TopNavigationBarProps {
	onClickLogo?: () => void;
	onClickLogout: () => void;
}

function TopNavigationBar(props: TopNavigationBarProps) {
	return (
		<AppBar
			position="fixed"
			style={{ backgroundColor: '#f1f9f8' }}
			elevation={0}>
			<Grid2
				container
				style={{ paddingLeft: '16px', backgroundColor: '#FFFFFF' }}
				alignItems={'center'}
				justifyContent={'space-between'}
				height={'50px'}>
				<IconButton disableRipple onClick={props.onClickLogo}>
					<Typography
						fontSize={'18px'}
						fontWeight={'700'}
						color={MAIN_THEME_COLOR}>
						Conversation Manager
					</Typography>
				</IconButton>
				<Button
					sx={{
						marginRight: '15px',
						color: MAIN_THEME_COLOR,
						textTransform: 'none',
					}}
					onClick={props.onClickLogout}>
					Logout
				</Button>
			</Grid2>
		</AppBar>
	);
}

export default TopNavigationBar;
